export { WalletAlreadyConnectedError } from './wallet-already-connected.error';
export { WalletNotConnectedError } from './wallet-not-connected.error';
export { WalletNotInjectedError } from './wallet-not-injected.error';
export { WalletNotSupportFeatureError } from './wallet-not-support-feature.error';
export { WalletMissingRequiredFeaturesError } from './wallet-missing-required-features.error';
